module.exports = __webpack_public_path__ + "img/buy.28ae03d0.svg";